/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-10T15:01:42.748
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentHouseOnlineEditInit,
	getRentHouseOnlineView
} from '@api/rentmanage/RentHouseOnline';

import {
listRentHouseOnlineItemInit,
listRentHouseOnlineItemByAuthorizations,
deleteRentHouseOnlineItem
} from '@api/rentmanage/RentHouseOnlineItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentHouseOnlineEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseOnlineEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseOnlineView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseOnlineView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
